import { Avatar } from '@material-ui/core';
import React from 'react';

export default function VCERNAvatar(props) {
    return <Avatar {...props} />;
}
